import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "../lib/data";

const Counter = ({ to, suffix = "", testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(to % 1 !== 0 ? Math.round(v * 10) / 10 : Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} data-testid={testId}>
      {typeof val === "number" && val % 1 !== 0 ? val.toFixed(1) : val.toLocaleString("ro-RO")}
      {suffix}
    </span>
  );
};

const STATS = [
  { value: 2019, suffix: "", label: "Din anul", raw: "2019" },
  { value: 50000, suffix: "+", label: "Pacienți îngrijiți" },
  { value: 4.9, suffix: "★", label: "Rating Google" },
  { value: 100, suffix: "%", label: "Tratament fără durere" },
];

const Stats = () => (
  <section className="bg-[#2A2521] py-16 lg:py-20" data-testid="stats-section">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-10">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.1} className="text-center">
          <div className="font-display text-4xl lg:text-5xl font-extrabold text-white">
            {s.raw ? <span data-testid={`stat-${i}`}>{s.raw}</span> : <Counter to={s.value} suffix={s.suffix} testId={`stat-${i}`} />}
          </div>
          <div className="mt-2 text-sm font-medium uppercase tracking-widest text-[#DCC79A]">{s.label}</div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Stats;
